import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";

import { GET_PARTNER_ACCOUNT } from "../../Action/actionTypes";

import { getPartnerAccountDataFailure, getPartnerAccountDataSuccess } from "../../Action";


function* getPartnerAccountRequest(action) {
    try {
        const {referralCode,currentPage,rowCount} = action?.payload?.payload
     
        const { data } = yield API.get(`/getPartnerAccount?referralCode=${referralCode}&currentPage=${currentPage}&rowCount=${rowCount}`);
     
        if (data?.code === 200) {
            yield put(getPartnerAccountDataSuccess(data?.data));

            if (action?.payload?.callback) {
                yield call(action.payload.callback, data);
            }
        } else {
            yield put(getPartnerAccountDataFailure());
             if (action?.payload?.callback) {
                yield call(action.payload.callback, data);
            }
           
        }
    } catch (error) {
        yield put(getPartnerAccountDataFailure());
       
    }
}

export function* watchGetPartnerAccountAPI() {
    yield takeEvery(GET_PARTNER_ACCOUNT, getPartnerAccountRequest);
}

export default function* rootSaga() {
    yield all([watchGetPartnerAccountAPI()]);
}
